<script setup>
import IntermediariesPeopleListComponent from "@/components/intermediaries-people/IntermediariesPeopleListComponent.vue";
import router from "@/router";

import {useI18n} from 'vue-i18n'

const {t} = useI18n();
</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-3">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> {{ t('general.back') }}</a>
        </div>
        <div class="col-5 text-center">
          <div class="page-section__title">
            {{ t('intermediaryPeopleIndex.intermediaries_people') }}
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="page-section__content">
    <div class="mt-3">
      <IntermediariesPeopleListComponent/>
    </div>
  </div>
</template>

<style scoped>
</style>
